import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import { ConfigProvider } from './components/ConfigContext';
import './i18n'; // initializes i18next (must run before any useTranslation call)
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <ConfigProvider>
            <App />
        </ConfigProvider>
    </React.StrictMode>,
);
